import SimpleModal from  '@/components/simple_modal'
import {useState} from 'react'; 
import PhotometryViewer from '@/components/photometry_viewer'
import PhotometrySvg from '@/components/svgs/photometry_svg'
export default function AssetPhotometryButton({product, fileId, _classes}) {
  const [show, setShow] = useState(false)

  return (
    <>
      {product.photometry_options &&
           <button
             className={_classes ? _classes : "lexcms-asset-photometry-viewer-button" }
             onClick={() => setShow(true)  } 
           >
             View
          </button>
      }
      
      {show &&
      <div className='lexcms-resources-modal-overlay'>
      <SimpleModal show={show} setShow={setShow}  additionalClasses={'lexcms-photometry-modal'} >
        <PhotometryViewer product={product} fileId={fileId} />
      </SimpleModal>
      </div>
      }

    </>
  )

}
